export const CURRENT_CONFIG = {

  // license
  appId: '180038', // 'Please enter the app id.', // You need to go to the development website to apply.
  appKey: '3d0c6d78dacc66f7fe718930a83af49', // 'Please enter the app key.', // You need to go to the development website to apply.
  appLicense: 'hUHuib2PVeLvzi+gziUDuNlSB3xWa0uXsGd6A7wlnL2S290/mePt8y1RSX5I1T3n488oGSx/kXcm6LAu42sA1rGRCMLO6dVen92qhmOc9lmR8BqmlBL1rGIA60CXRhHVY+GeEeYsnJJMlu0ognvhyxe8T4FI+XcLLwB/WnKlH/U=', // 'Please enter the app license.', // You need to go to the development website to apply.

  // http
  // baseURL: 'http://localhost:6789/', // 'Please enter the backend access address prefix.', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'ws://localhost:6789/api/v1/ws', // 'Please enter the WebSocket access address.', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // Esto que sigue es para producción
  baseURL: 'https://drones.qa.aigis.io', // 'https://drones.qa.aigis.io:6789/', // 'Please enter the backend access address prefix.', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://drones.qa.aigis.io/api/v1/ws', //  `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/api/v1/ws`, // 'ws://drones.qa.aigis.io:6789/api/v1/ws', // 'Please enter the WebSocket access address.', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://drones.qa.aigis.io:1935/live/', // 'rtmp://www.nideport.xyz/hls/', // 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  whipUrl: 'http://drones.qa.aigis.io:1985/rtc/v1/whip/?app=live&stream=',
  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
